<template>
  <div class="caption-head">
    <div class="caption-head-text" on-click>
      <span>Access</span>
    </div>
    <div class="caption-head-icon">
      <span class="active-chevron">
        <icon name="chevron-up"></icon>
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
//        data: {'name': 'Kol9I', 'name': 'Vas9I'}
      }
    },
    methods: {
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// accessArticles.vue?0c51b9fa